import {
  AfterViewInit,
  Directive,
  ElementRef,
  input,
  Renderer2,
} from '@angular/core';
import { AuthService } from '../../../services/auth';
import { RolesPrivilege, RolesAssignType } from '../../model';

@Directive({
  selector: '[appRolesPrivileges]',
})
export class RolesPrivilegesDirective implements AfterViewInit {
  public appRolesPrivileges = input<RolesAssignType>();

  constructor(
    private _authService: AuthService,
    private _el: ElementRef,
    private _renderer: Renderer2,
  ) {}

  /**
   * Lifecycle hook that is called after the component's view has been fully initialized.
   *
   * @memberof RolesPrivilegesDirective
   */
  ngAfterViewInit() {
    this.checkPrivileges();
  }

  /**
   * Checks if the user has the required role and updates the element's visibility accordingly.
   *
   * @memberof RolesPrivilegesDirective
   */
  private checkPrivileges() {
    this._authService.userRoles.subscribe((roles: RolesPrivilege) => {
      if (
        Object.keys(roles) &&
        Object.keys(roles).length &&
        this._authService.isAuthenticated() &&
        this.appRolesPrivileges()?.privilegeName
      ) {
        const hasPrivilege =
          (roles.privilegeIdentifiers &&
            roles.privilegeIdentifiers.length &&
            this.appRolesPrivileges()?.privilegeName?.some((privilege) =>
              roles.privilegeIdentifiers.includes(privilege),
            )) ||
          this.appRolesPrivileges()?.privilegeName?.length === 0
            ? true
            : false;

        const isAdmin =
          roles.roles &&
          roles.roles.length &&
          roles.roles.includes('System Admin');
        // If the type is 'HIDE', hide the element if the user does not have the privilege
        if (this.appRolesPrivileges()?.type === 'HIDE') {
          this._renderer.setStyle(
            this._el.nativeElement,
            'display',
            hasPrivilege
              ? window.getComputedStyle(this._el.nativeElement as Element)
                  .display
              : 'none',
          );
        }
        // If the type is 'DISABLE', disable the element if the user does not have the privilege
        if (this.appRolesPrivileges()?.type === 'DISABLE') {
          this._renderer.setProperty(
            this._el.nativeElement,
            'disabled',
            hasPrivilege ? false : true,
          );
        }
        if (this.appRolesPrivileges()?.role === 'ADMIN') {
          this._renderer.setStyle(
            this._el.nativeElement,
            'display',
            isAdmin
              ? window.getComputedStyle(this._el.nativeElement as Element)
                  .display
              : 'none',
          );
        }
      }
    });
  }
}
